import React, { Component } from "react";
import { Button } from "antd";
import moment from "moment";

import { apiReport } from "../../../api/api-report";
import { emitter } from "../../../common/utils/emitter";
import { alert } from "../../../common/utils/alert";
import BusinessReportModal from "./Modal/BusinessReportModal";
import OvetimeReportModal from "./Modal/OvetimeReportModal";
import OverKmReportModal from "./Modal/OverKmReportModal";
import TicketFeeReportModal from "./Modal/TicketFeeReportModal";

export class SummaryReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      timeFilter: moment().valueOf(),
      showBusinessReportModal: false,
      showOvetimeReportModal: false,
      showOverKmReportModal: false,
      showTicketFeeReportModal: false,
    };
  }

  handleExportBusinessReport = async () => {
    this.setState({ showBusinessReportModal: true });
  };

  onOkehandleExportBusinessReport = (query) => {
    try {
      this.setState({ showBusinessReportModal: false });
      emitter.emit("FETCH_LOADING", true);
      apiReport.exportLongPeriodReport(query).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  handleExportOvertimeReport = () => {
    this.setState({ showOvetimeReportModal: true });
  };

  onOkhandleExportOvertimeReport = (query) => {
    try {
      this.setState({ showOvetimeReportModal: false });
      emitter.emit("FETCH_LOADING", true);
      apiReport.exportOvertimeReport(query).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  handleExportKmReport = () => {
    this.setState({ showOverKmReportModal: true });
  };

  onOkehandleExportKmReport = (query) => {
    try {
      this.setState({ showOverKmReportModal: false });
      emitter.emit("FETCH_LOADING", true);
      apiReport.exportKmReport(query).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  handleExportTicketFee = () => {
    this.setState({ showTicketFeeReportModal: true });
  };

  onOkehandleExportTicketFee = (query) => {
    try {
      this.setState({ showTicketFeeReportModal: false });
      emitter.emit("FETCH_LOADING", true);
      apiReport.exportFeeReport(query).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  render() {
    const { errorMessage } = this.state;
    return (
      <div className="summary-report">
        <div
          style={{
            color: "#d20a30",
            paddingTop: "20px",
            fontSize: "1em",
            display: "flex",
            alignItems: "center",
          }}
        >
          Báo cáo tổng hợp
        </div>
        <div style={{ margin: "10px 0px" }}>
          Click chọn báo cáo để lọc theo các tiêu chí lọc
        </div>

        <div className="report-container">
          <Button
            className="export-btn"
            onClick={this.handleExportBusinessReport}
          >
            Xuất báo cáo kinh doanh dài hạn
          </Button>
          <Button
            className="export-btn"
            onClick={this.handleExportOvertimeReport}
          >
            Xuất báo cáo Overtime
          </Button>
          <Button className="export-btn" onClick={this.handleExportKmReport}>
            Xuất báo cáo Km
          </Button>
          <Button className="export-btn" onClick={this.handleExportTicketFee}>
            Xuất báo cáo chi phí vé
          </Button>
        </div>

        <BusinessReportModal
          visible={this.state.showBusinessReportModal}
          onOk={this.onOkehandleExportBusinessReport}
          onCancel={() => this.setState({ showBusinessReportModal: false })}
        />

        <OvetimeReportModal
          visible={this.state.showOvetimeReportModal}
          onOk={this.onOkhandleExportOvertimeReport}
          onCancel={() => this.setState({ showOvetimeReportModal: false })}
        />

        <OverKmReportModal
          visible={this.state.showOverKmReportModal}
          onOk={this.onOkehandleExportKmReport}
          onCancel={() => this.setState({ showOverKmReportModal: false })}
        />

        <TicketFeeReportModal
          visible={this.state.showTicketFeeReportModal}
          onOk={this.onOkehandleExportTicketFee}
          onCancel={() => this.setState({ showTicketFeeReportModal: false })}
        />
      </div>
    );
  }
}
